<template>
    <a class="nopic-content" :href="articleData.url" :data-spm-data="templateSpm">
        <h3 class="nopic-title">{{articleData.title}}</h3>
        <footer class="information">
            <span class="nopic-author">作者：{{articleData.author}}</span>
            <i class="right icon-link"></i>
        </footer>
    </a>
</template>

<script>
export default {
    name: 'ArtNopicItem',
}
</script>

<style lang="less" scoped>
    @import '../../less/base/mixins.less';
    #articleContent {
        .nopic-content {
            display: block;
            box-sizing: border-box;  
            padding: 26px 46px 34px 28px;
            border-radius: 6px;
            background: #F0F0F0;
            .information {
                margin-top: 16px;
            }
            .nopic-title {  
                max-height: 88px;/*px*/
                margin-bottom: 16px;
                font-size: 32px;/*px*/
                line-height: 44px;/*px*/
                overflow: hidden;
                .line-clamp(2); 
                color: #656565;
            }
            .nopic-author {
                font-size: 24px!important;/*px*/
                color: #A4A4A4;
            }
            .icon-link {
                font-size: 32px;/*px*/
                color: #6D98D4;
            }
        }
    }
</style>

